import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=fdd6dd0a"
import script from "./SearchBlock.vue?vue&type=script&lang=js"
export * from "./SearchBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchResultItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/search/ResultItem.vue').default})
